import { createContext, useState, useEffect } from "react";
import usePremiumStatus from "../components/subscription/stripe/UsePremiumStatus";
import {
  onAuthStateChangedListener,
  createUserDocumentFromAuth,
  getUserData,
} from "../../shared/utils/firebase/firebase.utils";

// the actual value you want to access
export const UserContext = createContext({
  currentUser: null,
  setCurrentUser: () => null,
  balance: 0,
});

export const UserProvider = ({ children }) => {
  const [downloadsUsed, setDownloads] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);
  const userIsPremium = usePremiumStatus(currentUser);
  const [displayName, setDisplayName] = useState("");
  const [subscriptions, setSubscriptions] = useState([]);
  const value = {
    currentUser,
    setCurrentUser,
    userIsPremium,
    downloadsUsed,
    setDownloads,
    displayName,
    setDisplayName,
    subscriptions,
  };

  useEffect(() => {
    const prices = {
      enterprise: -4999,
      personal: -999,
      professional: -1999,
    };

    const labels = {
      enterprise: "Enterprise",
      personal: "Personal",
      professional: "Professional",
    };
    const unsubscribe = onAuthStateChangedListener(async (user) => {
      if (user) {
        createUserDocumentFromAuth(user);
        localStorage.setItem("token", user.accessToken);
        const response = await getUserData(user, userIsPremium.paid);
        const userData = response.userData;
        const userSubscriptions = response.subscriptions;
        const userSubscriptionsFormatted = userSubscriptions.map(
          (subscriptionData, idx) => {
            return {
              id: idx,
              description: labels[subscriptionData.role],
              balanceChange: prices[subscriptionData.role],
              paidUntil: subscriptionData.current_period_end.seconds,
              timestamp: subscriptionData.created.seconds,
            };
          }
        );
        // need to format user subscriptions to this
        //     const transaction = {
        //       id: i,
        //       description: randomTransactionTemplate.description,
        //       balanceChange: randomTransactionTemplate.balanceChange,
        //       paidUntil: curUnix + oneMonthSeconds,
        //       timestamp: curUnix,
        //     };
        // console.log(userSubscriptionsFormatted);
        setSubscriptions(userSubscriptionsFormatted);
        if(userData) {
          if (userData.downloads) setDisplayName(userData.displayName);
          // console.log(userData);
          // console.log(userIsPremium.downloads);

          if (userData.downloads) setDownloads(userData.downloads.used);
        }
      }
      setCurrentUser(user);
    });
    return unsubscribe;
  }, [userIsPremium]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
